var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickEmptyCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.96 8.94 0 19.98 0C31.04 0 40 8.96 40 20C40 31.04 31.04 40 19.98 40C8.94 40 0 31.04 0 20ZM4.00011 20C4.00011 28.84 11.1601 36 20.0001 36C28.8401 36 36.0001 28.84 36.0001 20C36.0001 11.16 28.8401 4.00001 20.0001 4.00001C11.1601 4.00001 4.00011 11.16 4.00011 20Z",
    fill: "#12A963"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4853 27.379C17.2664 28.1601 18.5327 28.1601 19.3138 27.379L31.4505 15.2423C32.2315 14.4613 32.2315 13.195 31.4505 12.4139C30.6694 11.6329 29.4031 11.6329 28.622 12.4139L17.9001 23.1359L12.2428 17.4787C11.4618 16.6976 10.1955 16.6976 9.4144 17.4787C8.63335 18.2597 8.63335 19.526 9.4144 20.3071L16.4475 27.3402C16.4599 27.3533 16.4725 27.3662 16.4853 27.379Z",
    fill: "#12A963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickEmptyCircle);
export default __webpack_public_path__ + "static/media/tick-empty-circle.91cc43d32c3430e2fad59dfd98b6708b.svg";
export { ForwardRef as ReactComponent };